import React from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useLoaderData } from 'react-router-dom';
import './SuperInvoice.css';

const SuperInvoiceDetails = () => {

    const data = useLoaderData();

    const Invoice = data._id
    const InvoiceId = Invoice.slice(-6);

    console.log("data", data);

    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleButtonClick = (data) => {
        setSelectedItem(data);
        setIsOpen(!isOpen);
    };

    const handleVerify = id => {
        fetch(`https://tutor-tree-server-1.vercel.app/verifyingDataMainData/Verify/${id}`, {
            method: 'PUT',
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.modifiedCount > 0) {
                    toast.success('Verify Successful.')

                }
            })
            .catch(error => {
                console.error('Error:', error);
                // Handle any errors that occur during the request
            });
    }
    return (
        <div>
            <div className='w-full h-32 flex justify-center items-center bg-gray-50'>
                <h2 className='headingTxt'>All Invoice / Pending Payment</h2>
            </div>

            <div className='px-10'>
                <div className='flex items-center justify-between py-10  border-b-2 border-gray-200'>
                    <div><h1 className='headingText'>{data.teacherName}</h1></div>
                    {/* <div><h1 className='headingText'> {data.teacherEmail}</h1></div> */}
                    <div><h1 className='headingTextLink'>Back</h1></div>
                </div>
                <div className='flex items-center justify-between py-10'>
                    <div>
                        <h1 className='Invoice'>Invoice : <span className='jobDetails'>{InvoiceId}</span></h1>
                        <h1 className='Invoice mt-3'>Last Date :<span className='jobDetails'>{data.EndDate}</span> </h1>
                    </div>
                    <div>
                        <Link to={`/dashboardTwo/AllInvoiceJobDetails/${data._id}`}><h1 className='tutorDetails'>Job Details</h1></Link>
                        <button onClick={() => handleButtonClick(data)}><h1 className='tutorDetails mt-3'>Tutor Details</h1></button>
                    </div>
                </div>
                <div className='flex items-center justify-between mt-10'>
                    <div>
                        <h1 className='billedTo'>Billed To :</h1>
                        <h1 className='Invoice mt-5'>Name : <span className='invoicePera'>{data.teacherName}</span></h1>
                        <h1 className='Invoice mt-3'>Address : <span className='invoicePera'>{data.teachercity} {data.teacherarea}</span> </h1>
                        <h1 className='Invoice mt-3'>Phone : <span className='invoicePera'>{data.teacherPhone}</span> </h1>
                    </div>
                    <div>
                        <h1 className='billedTo'>From</h1>
                        <h1 className='InvoicePera mt-5'>Teacher Today</h1>
                        <h1 className='InvoicePera mt-3'>Sugandha, Panchlaish</h1>
                        <h1 className='InvoicePera mt-3'>teacherstoday.ctg@gmail.com</h1>
                    </div>
                </div>
                <div className='w-full bg-gray-100 h-16 flex justify-end items-center mt-10'>
                    <h1 className='textAmount mr-3'>Amount</h1>
                </div>
                <div className='w-full h-10 flex justify-between items-center mt-6'>
                    <h1 className='textAmount'>Job Id: {data.StudentsJobID}</h1>
                    <h1 className='textAmount mr-3'>{data.inputData} tk</h1>
                </div>


                <div className='flex flex-col justify-start'>


                    <div className='flex flex-col justify-start mt-5'>

                        <div className='flex flex-row w-full items-center '>
                            <div className='w-20'>
                                <h1 className='Paid'>Paid To:</h1>
                            </div>
                            <div className='w-32'>
                                <h1 className='paidPera'>+01629964650</h1>
                            </div>

                        </div>
                        <div className='flex flex-row w-full items-center mt-4'>
                            <div className='w-20'>
                                <h1 className='Paid'>Paid From:</h1>
                            </div>
                            <div className='w-32 ml-3'>
                                <h1 className='paidPera'>{data.inputNumber}</h1>
                            </div>

                        </div>
                        <div className='flex flex-row w-full items-center mt-4'>
                            <div className='w-36'>
                                <h1 className='Paid'>Payment Method:</h1>
                            </div>
                            <div className='w-32 ml-3'>
                                <h1 className='paidPera'>{data.paymentMethod}</h1>
                            </div>

                        </div>
                        <div className='flex justify-between'>
                            <div className='flex flex-row items-center mt-5'>
                                <div className='w-full'>
                                    <h1 className='Paid'>Amount:</h1>
                                </div>
                                <div className='w-full ml-3'>
                                    <h1 className='Paid'>{data.inputData}</h1>
                                </div>

                            </div>
                            <div className='flex flex-row items-center mt-5'>
                                <div className='flex flex-col'>
                                    <button onClick={() => handleVerify(data._id)} className='buttonSent'>Verify</button>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {isOpen && selectedItem && (
                <div className="container max-w-[1000px] mx-auto">
                <div className="contentApplication bg-white rounded-xl py-5 border border-gray-200">
                  <div className="flex flex-row  justify-between px-10 ">
                    <div>
                      <h1 className="modalTittleAppli">Tutor Details</h1>
                    </div>
                    <div className="flex justify-between">
                      <div>
                        <div className="flex justify-end items-center">
                          <button
                            onClick={() => setIsOpen(false)}
                            className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="h-2 mt-10 w-full"></hr>
    
                  {/* Display data from selectedItem in the modal */}
                  <div className="px-10">
                    <div className="w-full">
                      {/* <button onClick={handlePrint} className="text-right download">
                        Download
                      </button> */}
                    </div>
                    <div className="h-[600px] overflow-y-auto">
                      <div id="admissionForm">
                        <div className="rounded-lg border-2 mt-5">
                          <div className="px-5 py-3 flex justify-between items-center">
                            <h1 className="applicationModalOne">
                              Personal Information
                            </h1>
                          </div>
                          <hr className="h-2"></hr>
                          <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                            <div className="w-full pb-5">
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Name :</span>{" "}
                                {selectedItem.teacherName}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Gender :</span>{" "}
                                {selectedItem.teachercity}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Religion:</span>{" "}
                                {selectedItem.teacherReligion}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Phone :</span>{" "}
                                {selectedItem.teacherPhone}
                              </h1>
                            </div>
    
                            <div className="w-full pb-5">
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">City :</span>{" "}
                                {selectedItem.teachercity}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Area :</span>{" "}
                                {selectedItem.teacherarea}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera"></span>NID / Birth
                                Certificate / Passport{" "}
                              </h1>
                              <div className="flex w-20 flex-row justify-between items-center">
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherPersonalData1}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherPersonalData2}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherPersonalData3}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="rounded-lg border-2 mt-5">
                          <div className="px-5 py-3 flex justify-between items-center">
                            <h1 className="applicationModalOne">
                              Educational Information
                            </h1>
                          </div>
                          <hr className="h-2"></hr>
                          <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                            <div className="w-full pb-5">
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">
                                  Level of Education :
                                </span>{" "}
                                Masters
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Institute :</span>{" "}
                                {selectedItem.teacherMastersInstitute}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Certificate</span>
                              </h1>
                              <div className="flex w-20 flex-row justify-between items-center">
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherMastersFileUrls1}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherMastersFileUrls2}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherMastersFileUrls3}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
    
                            <div className="w-full pb-5">
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">
                                  Semester/Year :
                                </span>{" "}
                                {selectedItem.teacherMastersSemester}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">
                                  Major/Subject :
                                </span>{" "}
                                {selectedItem.teacherMastersMejor}
                              </h1>
                            </div>
                          </div>
                          <hr className="h-2 mt-3 mx-5"></hr>
                          <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                            <div className="w-full pb-5">
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">
                                  Level of Education :
                                </span>{" "}
                                Hons
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Institute :</span>{" "}
                                {selectedItem.teacherHonsInstitute}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Certificate</span>
                              </h1>
                              <div className="flex w-20 flex-row justify-between items-center">
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherHonsFileUrls1}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherHonsFileUrls2}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherHonsFileUrls3}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
    
                            <div className="w-full pb-5">
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">
                                  Semester/Year :
                                </span>{" "}
                                {selectedItem.teacherHonsSemester}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">
                                  Major/Subject :
                                </span>{" "}
                                {selectedItem.teacherHonsMajor}
                              </h1>
                            </div>
                          </div>
                          <hr className="h-2 mt-3 mx-5"></hr>
                          <div className="grid grid-cols-2 gap-10 pr-20 pl-5">
                            <div className="w-full pb-5">
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">
                                  Level of Education :
                                </span>
                                HSC
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Institute :</span>{" "}
                                {selectedItem.teacherHSCinstitute}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Certificate :</span>
                              </h1>
                              <div className="flex w-20 flex-row justify-between items-center">
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherHSCFile1}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherHSCFile2}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                                <a
                                  target="_blank"
                                  href={selectedItem.teacherHSCFile3}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="25"
                                    viewBox="0 0 19 25"
                                    fill="none"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                                      fill="#E5252A"
                                    />
                                    <path
                                      opacity="0.302"
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                                      fill="white"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
    
                            <div className="w-full pb-5">
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">Group :</span>{" "}
                                {selectedItem.teacherHSCgroup}
                              </h1>
                              <h1 className="text-left modalDetailsText mt-5">
                                <span className="modalTextPera">
                                  Passing Result :
                                </span>{" "}
                                {selectedItem.teacherHSCresult}
                              </h1>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="rounded-lg border-2 mt-5">
                        <div className="px-5 py-3 flex justify-between items-center">
                          <h1 className="applicationModalOne">
                            Teaching Experience
                          </h1>
                        </div>
                        <hr className="h-2"></hr>
                        <div className="px-5 py-4">
                          <p className="peraText">
                            {selectedItem.teacherExperience}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Add more elements to display other properties */}
                </div>
              </div>
            )}

        </div>
    );
};

export default SuperInvoiceDetails;